import * as React from "react";
import Modal from "../misc/components/modal";
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";
import { AuditForm } from "../auditmodal/components/AuditModal";
import { useWebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import { AuditTrailActionEnum } from "../misc/api/ApiAuditActions";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";

interface RevealPinModalProps {
    subjectId: string;
    onClose: () => void;
}

export const RevealPinModal = ({ subjectId, onClose }: RevealPinModalProps) => {
    const [pinRevealed, setPinRevealed] = React.useState(false);
    const [pin, setPin] = React.useState<string | undefined>();
    const client = useWebPortalApiClient();
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    const revealPin = async (form: AuditForm) => {
        const pinResult = await client.client.getSubject(subjectId, "number,pin");
        await client.client.postAuditTrailEvent({
            summary: `${fieldDisplayText.SubjectTerminology} '${pinResult.number}' PIN has been revealed`,
            auditAction: AuditTrailActionEnum.RevealPin,
            userAnnotation: form.Annotation,
        });
        setPin(pinResult.pin);
        setPinRevealed(true);
    }

    return (
        <Modal show={true} header="Reveal PIN" automationId="RevealPinModal">
            {
                pinRevealed ?
                    <PinRevealed pin={pin} onClose={onClose} />
                    : <AuditModalBody isAuditAnnotationDisabled={false} isSubmitting={false} onSubmit={(form) => revealPin(form)} onClose={onClose} annotationLabel="PIN Reveal Reason" submitLabel={`Reveal ${fieldDisplayText.SubjectTerminology} PIN`} />
            }
        </Modal>
    );
}

const PinRevealed = ({ pin, onClose }) => {
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    return (
        <>
            <div className="modal-body">
                <p>{`The ${fieldDisplayText.SubjectTerminology}'s PIN is:`}</p>
                <p style={{ fontSize: 500 + '%', textAlign: 'center' }} id="revealedPin">{pin}</p>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onClose} data-automationid="RevealPinModalCloseButton">Close</button>
            </div>
        </>
    );
}
